import React from 'react'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import { Stack, IconButton, Tooltip, Accordion, AccordionSummary, AccordionDetails, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MultiLangDialogAndSingleDisplayIpt from './MultiLangDialogAndSingleDisplayIpt';
import Iconify from '../../common/iconify/Iconify';
import { ICONIFY } from '../../../Constants/iconify';

// sidebar panel for options (radio/checkbox/dropdown)
export default function SbcOptions({
    data,
    handleOptions,
    handleSwitchChange,
    handleMultiIptChange,
    handleDragOptions
}) {

    const onDragEnd = ({ source, destination }) => {
        handleDragOptions(source, destination)
    }

    return (
        <Stack direction={'column'} spacing={1} >
            {/* Options Section */}
            <Accordion defaultExpanded className="sidebar-section">
                <AccordionSummary expandIcon={<ExpandMoreIcon />} className="sidebar-section-summary">
                    <Typography variant="caption">Options</Typography>
                </AccordionSummary>
                <AccordionDetails className="sidebar-section-details">
                    <DragDropContext onDragEnd={onDragEnd}>
                        <Droppable droppableId={data?.id}>
                            {(provided) => {
                                return (
                                    <div {...provided.droppableProps} ref={provided.innerRef}>
                                        {data?.answerOptionList && data?.answerOptionList?.map((op, idx) =>
                                            <Draggable key={idx} draggableId={'' + idx} index={idx}>
                                                {(provided) => {
                                                    return (
                                                        <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                                                            <Stack direction={'row'} alignItems={'center'} gap={1} mt={1} mb={1}>
                                                                <Iconify icon={ICONIFY.drag} />
                                                                <MultiLangDialogAndSingleDisplayIpt
                                                                    key={op?.key || idx}
                                                                    item
                                                                    optionIdx={idx}
                                                                    keyName={'answerOptionList'}
                                                                    itemKeyName={op?.key}
                                                                    valueObj={op?.value}
                                                                    label={op?.label}
                                                                    price={op?.price}
                                                                    inputType={op?.inputType}
                                                                    handleMultiIptChange={handleMultiIptChange}
                                                                    handleOptions={handleOptions}
                                                                />
                                                            </Stack>
                                                        </div>
                                                    )
                                                }}
                                            </Draggable>
                                        )}
                                    </div>
                                )
                            }}
                        </Droppable>
                    </DragDropContext>

                    <Tooltip title="create option">
                        <IconButton disableRipple color='success' onClick={handleOptions('c')}>+</IconButton>
                    </Tooltip>
                </AccordionDetails>
            </Accordion>
        </Stack>
    )
}
